import { LayoutRoute, Route } from "@soft-db/typed-router";

const reportRoutes = new LayoutRoute({
	name: "reports",
	path: "reports",
	meta: {
		feature: "report",
		permission: "report.get",
	},
	component: () => import("@/pages/reports.vue"),
	children: [
		new Route({
			path: "",
			component: () => import("@/pages/reports/index.vue"),
		}),
		new Route({
			path: ":id",
			meta: { permission: "report.update" },
			component: () => import("@/pages/reports/_id.vue"),
			redirect: { name: "reports-id-settings" },
			children: [
				new Route({
					path: "settings",
					component: () => import("@/pages/reports/_id/index.vue"),
				}),
			],
		}),
	],
});

export default reportRoutes;
